import { Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import DriverPage from "./pages/DriverPage";
import AdminPage from "./pages/AdminPage";
import AdminCars from "./components/admin/adminCars/AdminCars";
import AdminDrivers from "./components/admin/adminDrivers/AdminDrivers";
import WeeklyReport from "./components/admin/adminWeeklyReport/WeeklyReport";
import DailyReport from "./components/admin/adminDailyReport/DailyReport";
import MonthlyReport from "./components/admin/adminMonthlyReport/MonthlyReport";

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="driver" element={<DriverPage />} />
      <Route path="admin" element={<AdminPage />}>
        <Route path="cars" element={<AdminCars />} />
        <Route path="drivers" element={<AdminDrivers />} />
        <Route path="day" element={<DailyReport />} />
        <Route path="week" element={<WeeklyReport />} />
        <Route path="month" element={<MonthlyReport />} />
      </Route>
    </Routes>
  );
}

export default App;
